import Page from '@admin/components/page'
import Publishings from './publishings'
import Copyright from './copyright'
import Overview from './overview'
import Variants from './variants'
import Design from './design'
import React from 'react'

const mapPropsToPage = (props, context, resources, page) => ({
  title: resources.email_campaign.title,
  manager: {
    path: `/admin/truevail/admin/email_campaigns/${resources.email_campaign.id}`,
    items: [
      {
        label: 't(Overview)',
        panel: <Overview email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Variants)',
        path: '/variants',
        panel: <Variants email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Design)',
        path: '/design',
        panel: <Design email_campaign={ resources.email_campaign }  />
      },
      {
        label: 't(Copyright)',
        path: '/copyright',
        panel: <Copyright email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Publishings)',
        path: '/publishings',
        panel: <Publishings email_campaign={ resources.email_campaign }  />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  email_campaign: `/api/admin/truevail/admin/email_campaigns/${props.params.id}`
})

export default Page(mapResourcesToPage, mapPropsToPage)
